import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Headphones, Menu, Search, ShoppingCart, X } from "lucide-react";
import { useShopify } from "../context/StoreContext";
import logo from "../assets/logo-ROMI-fondo.png";
import "./Navbar.css";

export default function Navbar() {
  const navigate = useNavigate();
  const { getCartCount } = useShopify();
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const count = getCartCount();

  const submit = (event) => {
    event.preventDefault();
    const value = search.trim();
    if (value) navigate(`/catalogo?search=${encodeURIComponent(value)}`);
    setOpen(false);
  };

  return (
    <>
      <div className="store-announcement">
        <span>Envío gratis a todo Ecuador</span>
        <span>Pago seguro contra entrega</span>
        <span>Atención personalizada</span>
      </div>
      <header className="store-header">
        <div className="store-header__main">
          <button className="store-menu-button" onClick={() => setOpen(true)} aria-label="Abrir menú"><Menu /></button>
          <Link className="store-logo" to="/" aria-label="ROMI STORE inicio"><img src={logo} alt="ROMI STORE" /><span><strong>ROMI</strong> STORE<small>ECUADOR</small></span></Link>
          <form className="store-search" onSubmit={submit}><input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="¿Qué estás buscando?" aria-label="Buscar productos" /><button aria-label="Buscar"><Search /></button></form>
          <Link className="store-support" to="/contacto"><Headphones /><span><small>¿Necesitas ayuda?</small>Contáctanos</span></Link>
          <Link className="store-cart" to="/carrito" aria-label={`Carrito con ${count} productos`}><ShoppingCart />{count > 0 && <b>{count}</b>}<span>Carrito</span></Link>
        </div>
        <nav className={`store-nav ${open ? "is-open" : ""}`}>
          <div className="store-nav__mobile-head"><span>Menú</span><button onClick={() => setOpen(false)}><X /></button></div>
          <NavLink to="/" onClick={() => setOpen(false)}>Inicio</NavLink>
          <NavLink to="/catalogo" onClick={() => setOpen(false)}>Todos los productos</NavLink>
          <NavLink to="/catalogo/hogar-decoracion" onClick={() => setOpen(false)}>Hogar</NavLink>
          <NavLink to="/catalogo/belleza-salud" onClick={() => setOpen(false)}>Belleza y salud</NavLink>
          <NavLink to="/catalogo/tecnologia" onClick={() => setOpen(false)}>Tecnología</NavLink>
          <NavLink to="/catalogo/moda-ropa" onClick={() => setOpen(false)}>Moda</NavLink>
          <NavLink to="/ofertas-virales" onClick={() => setOpen(false)}>Ofertas virales</NavLink>
          <NavLink to="/premios" className="store-nav__reward" onClick={() => setOpen(false)}>Caja Misteriosa</NavLink>
          <form className="store-search store-search--mobile" onSubmit={submit}><input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar productos" /><button><Search /></button></form>
        </nav>
        {open && <button className="store-nav-backdrop" onClick={() => setOpen(false)} aria-label="Cerrar menú" />}
      </header>
    </>
  );
}
